module.exports = __webpack_public_path__ + "media/img/frontend_application/venue/karaoke-icon-d471c4071c24169b93f6567e944af379.png";